import React, { useState } from 'react';
import PropTypes from 'prop-types';

const AddCommentInput = ({ addComment }) => {
  const [commentText, setCommentText] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    addComment(commentText);
    setCommentText('');
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <input type="text"
        placeholder='Add a comment'
        value={commentText}
        onChange={(e) => setCommentText(e.target.value)}
        style={{ flex: 1 }}
      />
      {commentText && (
        <button onClick={handleSubmit}
          style={{ marginLeft: 'auto' }}
        >{'Post'}</button>
      )}
    </div>
  );
};

AddCommentInput.propTypes = {
  addComment: PropTypes.func.isRequired,
};

export default AddCommentInput;
